import axios from 'axios';
import { publicIpv4 } from 'public-ip';
import { basicToken, config } from '../config';

const baseURL = `${config?.baseUrl}${config?.version}`;

const getDefaultHeaders = async () => {
  let publicIp = await publicIpv4();
  axios.defaults.headers.common['X-Forwarded-For'] = publicIp;
  axios.defaults.headers.common['X-Real-Ip'] = publicIp;
}

export const getSubDomain = (host) => {
  try {
    const domains = host?.split('.');
    //const domains = ['sk', 'pc-staging', 'com'];
    const initialDomain = domains?.find(
      (element) => element == config.siteURL.split('.')[0]
    );
    if (initialDomain) {
      const subdomain = host?.split('.')[0];
      return subdomain;
    } else {
      return host;
    }
  } catch (error) {
    console.log(error);
  }
};

export const getFranchisee = async (domain) => {
  await getDefaultHeaders()
  try {
    const response = await axios({
      url: `/franchisees/store_name/${domain}`,
      method: 'get',
      baseURL: baseURL,
      headers: {
        'Authorization': basicToken,
      }
    });
    if (response?.data?.domain && response?.data?.domain != '') {
      localStorage.setItem('isCustomDomain', 'true');
    } else {
      localStorage.setItem('isCustomDomain', 'false');
    }
    return response.data;
  } catch (error) {
    console.error(error);
    return error.response.data;
  }
};

export const getFranchiseeNew = async (domain) => {
  await getDefaultHeaders()
  try {
    const response = await axios({
      url: `/franchisees/store_name/${domain}`,
      method: 'get',
      baseURL: baseURL,
      headers: {
        'Authorization': basicToken,
      }
    });
    if (response?.data?.domain && response?.data?.domain != '') {
      localStorage.setItem('isCustomDomain', 'true');
    } else {
      localStorage.setItem('isCustomDomain', 'false');
    }
    return response.data;
  } catch (error) {
    console.error(error);
    return error.response.data;
  }
};

export const checkAdminType = async (domain) => {
  await getDefaultHeaders()
  try {
    const response = await axios({
      url: `/franchisees/store_name/${domain}`,
      method: 'get',
      baseURL: `${config?.baseUrl}/api/v2`,
      headers: {
        'Authorization': basicToken,
      }
    });
    if (response?.data?.domain && response?.data?.domain != '') {
      localStorage.setItem('isCustomDomain', 'true');
    } else {
      localStorage.setItem('isCustomDomain', 'false');
    }
    return response.data;
  } catch (error) {
    console.error(error);
    return error.response.data;
  }
};
